<div class="text-center p-4">
  <!-- Botón de cierre (X) -->
  <button
    type="button"
    class="btn-close position-absolute top-0 end-0 m-3 f-10"
    aria-label="Close"
    (click)="closeDialog('close')"
  ></button>

  <div class="mb-3 mt-2">
    <img
      src="https://res.cloudinary.com/pervolare-org/image/upload/v1761699125/TAS/rutt/alert-triangle_xaxcef.png"
      alt="icon"
    />
  </div>

  <h5 class="fw-bold mb-2 text-muted">
    Al continuar con una cuenta bancaria de un tercero
  </h5>

  <p class="text-muted f-16 mb-2">
    <strong>Traveler Assistance</strong> no se responsabiliza por la tenencia ni
    manejo de la transferencia.
  </p>
  <p class="fw-bold f-16 mb-3 text-muted">
    ¿Aceptas los Términos y Condiciones?
  </p>

  <button
    class="btn btn-primary w-100 fw-bold"
    (click)="closeDialog('finalizar')"
  >
    Sí, acepto
  </button>
  <div class="mt-2">
    <a class="text-primary fw-medium f-14" (click)="closeDialog('modificar')">
      No, modificar
    </a>
  </div>
</div>
